export default __webpack_public_path__ + "static/media/analytics.03f6d351.png";